import { useMemo } from 'react';
import { useTenant } from '../contexts/TenantContext';
import { DEFAULT_AI_MODEL } from '../constants/aiModels';

/**
 * Effective default AI model for new card runs: tenant setting, else platform default.
 */
export function useTenantDefaultAiModel() {
  const { currentTenant } = useTenant();
  return useMemo(() => {
    const raw = currentTenant?.defaultAiModel ?? currentTenant?.DefaultAIModel;
    if (typeof raw === 'string' && raw.trim()) {
      return raw.trim();
    }
    return DEFAULT_AI_MODEL;
  }, [currentTenant?.defaultAiModel, currentTenant?.DefaultAIModel]);
}
